export default __webpack_public_path__ + "static/robert-b513c9b46dcdf22edd8d2b443b93e1e1.png";